import {store} from '@eitje/bridge'

export const INITIAL_ADVANCED_TABLE_STATE = {
	pinned: [], // used for sort
	unpinned: [], // used for sort
	visible: [],
	grouped: null,
	sorting: [],
}

export const writeStore = (tableName, value) => {
	store.dispatch({tableName, type: 'ADVANCED_TABLE', value})
}
